import React, {Fragment} from 'react';
import { bindActionCreators } from "redux";
import Draggable from 'react-draggable';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import actions  from "react/api/actions";
const { licenseStatusModal: { actionCreators } } = actions;    

export class LicenseStatusModal extends React.Component {

  classNameBase = (suffix) => (`licenseModal-status-modal${suffix || ""}`);

  defaultClassName = () => {
    const { resource } = this.props;
    //replace resource name, transforms "CamelCase.CamelCase" to "camel-case-camel-case";
    const className = `--${resource.replace(/([a-z])([A-Z])/g, '$1-$2').replace('.', '-').toLowerCase()}`;
    return `${this.classNameBase()} ${this.classNameBase(className)}`; 
  }

  setRef = (element) => {
    this.licenseStatusModalHTMLElement = element; 
  }

  toggle = () => {
    const { isExpanded, licenseStatusModalActions } = this.props;
    if (isExpanded) {
      licenseStatusModalActions.retractLicenseStatusModal();
    } else {
      licenseStatusModalActions.expandLicenseStatusModal();
    }
  }

  closeModal = () => {
    const { licenseStatusModalActions } = this.props;
    licenseStatusModalActions.closeLicenseStatusModal();
  }

  updatePosition = (e, pos) => {

    const { licenseStatusModalActions, position, isOpen } = this.props;
    
    if (isOpen) {
      
      if(pos) {

        const coords = pos || this.licenseStatusModalHTMLElement.getBoundingClientRect();
        const isNegativeYPos = (coords.y + this.licenseStatusModalHTMLElement.offsetHeight) < 0;
        const isPositiveYPos = coords.y > window.innerHeight;
        const isNegativeXPos = (coords.x + this.licenseStatusModalHTMLElement.offsetWidth) < 0;
        const isPositiveXPos = coords.x > window.innerWidth;
        
        let x;
        let y;
        
        if (isNegativeXPos) {
          x = 0;
        } else if (isPositiveXPos) {
          x = (window.innerWidth - this.licenseStatusModalHTMLElement.offsetWidth);
        } else {
          x = coords.x;
        }
  
        if (isNegativeYPos) {
          y = 0;
        } else if (isPositiveYPos) {
          y = (window.innerHeight - this.licenseStatusModalHTMLElement.offsetHeight);
        } else {
          y = coords.y;
        }
        licenseStatusModalActions.setLicenseStatusModalPosition({ x, y });

      } else if (!position.has('x') && !position.has('y')) {
        //shows modal centered on screen
        const x = ((window.innerWidth - this.licenseStatusModalHTMLElement.offsetWidth)/2);
        const y = ((window.innerHeight - this.licenseStatusModalHTMLElement.offsetHeight)/2);
        licenseStatusModalActions.setLicenseStatusModalPosition({ x, y });
      }
    }
  }

  addListeners = () => {
    window.addEventListener("resize", this.updatePosition);
  }

  removeListeners = () => {
    window.removeEventListener("resize", this.updatePosition);
  }

  componentDidMount = () => {
    this.addListeners();
  }

  componentDidUpdate = () => {
    this.updatePosition();
  }

  componentWillUnmount = () => {
    this.removeListeners();
  }

  render() {

    const { isOpen, isExpanded, isCancelable, resource, position } = this.props;
    return (
      <Fragment>
        { isOpen && <Draggable
        defaultClassName={this.defaultClassName()}
        defaultClassNameDragging={this.classNameBase("--dragging")}
        defaultClassNameDragged={this.classNameBase("--dragged")}
        position={position.toJS()}
        onStop={this.updatePosition}
        >
          <div ref={this.setRef} className={{
            [`${this.classNameBase("--expanded")}`]: isExpanded,
            [`${this.classNameBase("--retracted")}`]: !isExpanded,
            [`${this.classNameBase("--cancelable")}`]: isCancelable
          }}>
              <div className={this.classNameBase("-header")}>
                <div className={this.classNameBase("-title")}>
                  { isCancelable && <i className={this.classNameBase("-toggle-icon")} onClick={this.toggle}></i> }
                  { Monet.I18n.getResourcesByKey('LicenseStatusModal.title') }
                </div>
                { !isExpanded && <span className={this.classNameBase("-truncated-text")}>  - { Monet.I18n.getResourcesByKey(`${resource}`) } </span> }
                { isCancelable && <i className={this.classNameBase("-close-icon")} onClick={this.closeModal}></i> }
                { !isCancelable && <i className={this.classNameBase("-toggle-icon")} onClick={this.toggle}></i> }
              </div>
              <div className={this.classNameBase("-body")}>
                <p> { Monet.I18n.getResourcesByKey(`${resource}`) } </p>
              </div>
          </div>
        </Draggable> }
      </Fragment>
    );
  }
}

LicenseStatusModal.propTypes = {
  isCancelable: PropTypes.bool.isRequired,
  isExpanded: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired,
  resource: PropTypes.string.isRequired,
  position: PropTypes.object.isRequired,
  licenseStatusModalActions: PropTypes.object.isRequired
}

const mapStateToProps = ({ licenseStatusModal }) => ({
  isCancelable: licenseStatusModal.get("isCancelable", false),
  isOpen: licenseStatusModal.get("isOpen", false),
  isExpanded: licenseStatusModal.get("isExpanded", true),
  resource: licenseStatusModal.get("resource", ""),
  position: licenseStatusModal.get("position")
});

const mapDispatchToProps = (dispatch) => ({
  licenseStatusModalActions: bindActionCreators(actionCreators, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(LicenseStatusModal);
